import { ImageLoaderCSSStyleImpl } from '../../../../ui/toolkit/imageloader/imageloadercss';


export class PlaylistDetailsImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '100%',
            borderRadius:'8px'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/playlistdetails/playlistdetailsimageloadercss.ts